<template>
    <v-modal title="Edit Lead Sources" @close="$emit('close')" :scroll="true">
        <div slot="content">
            <p class="stack-m">Edit your customer lead source information.</p>
            <div class="grid-content">
                <div class="grid-item grid-item-full" v-for="key in editableFields">
                    <template v-if="key === 'currency'">
                        <div class="field" :class="{'is-error' : $v.leadSource.amount.$error}">
                            <label class="field-label">Currency &amp; Amount</label>
                            <div class="field-group">
                                <v-select
                                    class="no-flex lead-sources-currency"
                                    optionLabel="value"
                                    :options="currenciesList"
                                    :preselectFirst="true"
                                    placeholder=""
                                    v-model="leadSource.currency"
                                />
                                <input
                                    class="field-input"
                                    v-model="leadSource.amount"
                                    @input="preventEmpty"
                                />
                            </div>
                        </div>
                    </template>
                    <template v-if="key !== 'amount' && key !== 'currency'">
                        <r-input
                            :label="key | unCamelCase | capitalize"
                            v-model="leadSource[key]"
                        />
                    </template>
                </div>
            </div>
        </div>
        <template slot="actions">
            <r-button type="primary" @click="save">Save</r-button>
        </template>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import {
        vIcon, vSelect,
    } from '@/components/form';
    import LeadSourceModel from '@/common/models/lead-source-model';
    import {CURRENCIES_LIST} from '@/data/currencies';
    import decimal from 'vuelidate/lib/validators/decimal';

    export default {
        name: 'lead-source-modal-modal',
        components: {
            vModal,
            vIcon,
            vSelect,
        },
        props: {
            entry: {
                type: Object,
            },
        },
        validations: {
            leadSource: {
                amount: {
                    decimal,
                },
            },
        },
        data() {
            return {
                currenciesList: CURRENCIES_LIST,
                leadSource: new LeadSourceModel(this.entry),
                editableFields: LeadSourceModel.editableFields,
            };
        },
        computed: {
            selectedCurrency: {
                cache: false,
                get() {
                    return this.currencies.find(
                        currency => currency.iso === this.leadSource.currency,
                    );
                },
                set(value) {
                    if (value !== null) {
                        this.leadSource.currency = value.iso;
                    } else {
                        this.leadSource.currency = null;
                    }
                },
            },
        },
        methods: {
            preventEmpty() {
                if (!this.leadSource.amount) {
                    this.leadSource.amount = null;
                    this.leadSource.currency = null;
                }
            },
            save() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.preventEmpty();
                    this.$emit('update', this.leadSource);
                    this.$emit('close');
                }
            },
        },
    };
</script>
